import { Link } from 'react-router-dom'
import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { TeacherExamList } from '../../../components/teacher-exam-list'
import { CreatedExams } from '../../../components/created-exams'
import { ScoredExams } from '../../../components/scored-exams'
import { FilterBtn } from '../../../styles/results'

const TeacherExamination = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <Link to='/teacher/examination/create'>
                            <FilterBtn>
                                CREATE EXAM
                            </FilterBtn>
                        </Link>
                        <Heading>
                            Examination
                        </Heading>
                        <Breadcrumb
                            crumbs={['Examination']}
                        />
                        <TeacherExamList />
                        <CreatedExams />
                        <ScoredExams />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default TeacherExamination
